/* global CKEDITOR, grecaptcha */

const comment = {
  addRecaptcha: () => {
    const commentForm = document.querySelector('.comment-form');

    commentForm.addEventListener('submit', e => {
      e.preventDefault();

      grecaptcha
        // The `action` identifies the submission of this particular form in the Google reCAPTCHA
        // dashboard.
        .execute(document.body.dataset.recaptchaPublicKey, { action: 'comment' })
        .then(token => {
          const recaptchaInput = document.querySelector('.g-recaptcha');

          recaptchaInput.value = token;

          commentForm.submit();
        });
    });
  },
  configureCkeditor: () => {
    const instance = CKEDITOR.instances.id_content;

    if (instance) {
      instance.on('fileUploadRequest', evt => {
        evt.data.fileLoader.xhr.setRequestHeader(
          'X-CSRFToken',
          document.cookie.split('csrftoken=')[1]
        );
      });
    }

    CKEDITOR.on('instanceReady', () => {
      const editor = CKEDITOR.instances.id_content;
      const csrfTokenRegexp = /csrftoken=([A-z0-9]+);?/;

      // eslint-disable-next-line prefer-destructuring
      editor.config.s3UploadImage.csrfToken = document.cookie.match(csrfTokenRegexp)[1];
    });

    CKEDITOR.on('dialogDefinition', evt => {
      const dialogName = evt.data.name;
      const dialogDefinition = evt.data.definition;

      if (dialogName === 'image') {
        const imageInfo = dialogDefinition.getContents('info');
        const imagePreview = imageInfo.get('htmlPreview');

        imagePreview.className = 'ckeditor-image-preview';

        imageInfo.get('basic').className = 'ckeditor-image-details';

        imagePreview.onLoad = () => {
          document
            .querySelector('.ckeditor-image-preview')
            .parentNode.classList.add('ckeditor-image-preview-container');
        };
      }
    });
  },
  scrollIntoView: () => {
    const item = document.querySelector('.js-comment-form-error');

    if (item) {
      item.scrollIntoView();
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // We only use the reCAPTCHA when adding comments, so it'll be `undefined` when editing them.
  if (typeof grecaptcha !== 'undefined') {
    grecaptcha.ready(comment.addRecaptcha);
  }

  comment.scrollIntoView();
  comment.configureCkeditor();
});

export { comment };
